import React from "react";
import { Tooltip } from "@mui/material";

// Shows the full text of a truncated description on hover (tap on mobile).
// Renders the children unchanged when there is no text to show.
const DescriptionTooltip = ({ title, children }) => {
  if (!title) return children;

  return (
    <Tooltip
      title={String(title)}
      arrow
      placement="top"
      enterTouchDelay={0}
      leaveTouchDelay={5000}
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 400,
            whiteSpace: "pre-wrap",
            bgcolor: "background.paper",
            color: "text.primary",
            border: "1px solid",
            borderColor: "divider",
            boxShadow: 1,
            fontSize: "14px",
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default DescriptionTooltip;
